import Main from "./screens/Main";

export { Main };
